import { Icons } from '@/components/Shares/Icons';
import { ActionIcon } from '@mantine/core';
import classes from './Aside.module.css';
export type ChatActionButtonProps = {
  iconName: string;
  active: boolean;
  handleClick: () => void;
};
export const ChatActionButton: React.FC<ChatActionButtonProps> = ({
  iconName,
  active,
  handleClick
}) => {
  return <ActionIcon variant="filled" onClick={handleClick} mod={{
    active: active
  }} className={classes.chatIcon}>
      <Icons className={iconName} fontSize={18} />
    </ActionIcon>;
};